<component v-if="shouldRenderConfig" v-show="alwaysShow || getShowUpload" v-bind:is="getContainerType" v-bind:class="getClassName">
    <appConnectButton></appConnectButton>
    <appUpload
        v-for="(pp,key) in getProductPartsNames"
        v-bind:key="pp.code"
        v-bind:propsData="pp"
        v-bind:alwaysShow=alwaysShow
    ></appUpload>
</component>